module.exports = __webpack_public_path__ + "static/media/front-document.aa10e9c3.png";